var map = {
	"./asscher_alexandrite.jpg": 70280,
	"./asscher_amethyst.jpg": 64904,
	"./asscher_ametrine.jpg": 56926,
	"./asscher_apatite.jpg": 9945,
	"./asscher_aquamarine.jpg": 18207,
	"./asscher_beryl.jpg": 2670,
	"./asscher_chrysoberyl.jpg": 18505,
	"./asscher_citrine.jpg": 24418,
	"./asscher_emerald.jpg": 94822,
	"./asscher_garnet.jpg": 64432,
	"./asscher_heliodor.jpg": 83742,
	"./asscher_iolite.jpg": 82032,
	"./asscher_kunzite.jpg": 2906,
	"./asscher_moonstone.jpg": 59939,
	"./asscher_morganite.jpg": 89978,
	"./asscher_opal.jpg": 37144,
	"./asscher_peridot.jpg": 94262,
	"./asscher_quartz.jpg": 18001,
	"./asscher_ruby.jpg": 38007,
	"./asscher_sapphire.jpg": 52989,
	"./asscher_sphene.jpg": 64254,
	"./asscher_spinel.jpg": 39365,
	"./asscher_tanzanite.jpg": 41235,
	"./asscher_topaz.jpg": 17415,
	"./asscher_tourmaline.jpg": 90279,
	"./asscher_zircon.jpg": 77430,
	"./emerald_alexandrite.jpg": 42827,
	"./emerald_amethyst.jpg": 87427,
	"./emerald_ametrine.jpg": 94742,
	"./emerald_apatite.jpg": 56924,
	"./emerald_aquamarine.jpg": 12825,
	"./emerald_beryl.jpg": 67526,
	"./emerald_chrysoberyl.jpg": 72919,
	"./emerald_citrine.jpg": 35423,
	"./emerald_emerald.jpg": 36862,
	"./emerald_garnet.jpg": 95442,
	"./emerald_heliodor.jpg": 78552,
	"./emerald_iolite.jpg": 82564,
	"./emerald_kunzite.jpg": 62543,
	"./emerald_moonstone.jpg": 73950,
	"./emerald_morganite.jpg": 98886,
	"./emerald_opal.jpg": 96819,
	"./emerald_peridot.jpg": 96046,
	"./emerald_quartz.jpg": 31109,
	"./emerald_ruby.jpg": 49970,
	"./emerald_sapphire.jpg": 25602,
	"./emerald_sphene.jpg": 63946,
	"./emerald_spinel.jpg": 10605,
	"./emerald_tanzanite.jpg": 91292,
	"./emerald_topaz.jpg": 89726,
	"./emerald_tourmaline.jpg": 89673,
	"./emerald_zircon.jpg": 15538,
	"./heart_alexandrite.jpg": 28075,
	"./heart_amethyst.jpg": 606,
	"./heart_ametrine.jpg": 75409,
	"./heart_apatite.jpg": 85054,
	"./heart_aquamarine.jpg": 72676,
	"./heart_beryl.jpg": 89050,
	"./heart_chrysoberyl.jpg": 48733,
	"./heart_citrine.jpg": 51543,
	"./heart_emerald.jpg": 76251,
	"./heart_garnet.jpg": 99615,
	"./heart_heliodor.jpg": 39358,
	"./heart_iolite.jpg": 74623,
	"./heart_kunzite.jpg": 42046,
	"./heart_moonstone.jpg": 72614,
	"./heart_morganite.jpg": 64452,
	"./heart_opal.jpg": 56635,
	"./heart_peridot.jpg": 66656,
	"./heart_quartz.jpg": 99947,
	"./heart_ruby.jpg": 21285,
	"./heart_sapphire.jpg": 59921,
	"./heart_sphene.jpg": 97216,
	"./heart_spinel.jpg": 20175,
	"./heart_tanzanite.jpg": 88663,
	"./heart_topaz.jpg": 9628,
	"./heart_tourmaline.jpg": 10107,
	"./heart_zircon.jpg": 26562,
	"./marquise_alexandrite.jpg": 61712,
	"./marquise_amethyst.jpg": 65658,
	"./marquise_ametrine.jpg": 64902,
	"./marquise_apatite.jpg": 44285,
	"./marquise_aquamarine.jpg": 65921,
	"./marquise_beryl.jpg": 97692,
	"./marquise_chrysoberyl.jpg": 65915,
	"./marquise_citrine.jpg": 36133,
	"./marquise_emerald.jpg": 64565,
	"./marquise_garnet.jpg": 30626,
	"./marquise_heliodor.jpg": 73048,
	"./marquise_iolite.jpg": 89216,
	"./marquise_kunzite.jpg": 9612,
	"./marquise_moonstone.jpg": 82973,
	"./marquise_morganite.jpg": 63292,
	"./marquise_opal.jpg": 74691,
	"./marquise_peridot.jpg": 35262,
	"./marquise_quartz.jpg": 71364,
	"./marquise_ruby.jpg": 76651,
	"./marquise_sapphire.jpg": 47601,
	"./marquise_sphene.jpg": 74939,
	"./marquise_spinel.jpg": 67326,
	"./marquise_tanzanite.jpg": 89478,
	"./marquise_topaz.jpg": 54234,
	"./marquise_tourmaline.jpg": 94972,
	"./marquise_zircon.jpg": 45091,
	"./oval_alexandrite.jpg": 87438,
	"./oval_amethyst.jpg": 61875,
	"./oval_ametrine.jpg": 68905,
	"./oval_apatite.jpg": 33086,
	"./oval_aquamarine.jpg": 22446,
	"./oval_beryl.jpg": 42740,
	"./oval_chrysoberyl.jpg": 40189,
	"./oval_citrine.jpg": 21558,
	"./oval_emerald.jpg": 2765,
	"./oval_garnet.jpg": 37449,
	"./oval_heliodor.jpg": 59320,
	"./oval_iolite.jpg": 44302,
	"./oval_kunzite.jpg": 47795,
	"./oval_moonstone.jpg": 91103,
	"./oval_morganite.jpg": 827,
	"./oval_opal.jpg": 76906,
	"./oval_peridot.jpg": 80544,
	"./oval_quartz.jpg": 27587,
	"./oval_ruby.jpg": 51716,
	"./oval_sapphire.jpg": 81128,
	"./oval_sphene.jpg": 37477,
	"./oval_spinel.jpg": 88399,
	"./oval_tanzanite.jpg": 94949,
	"./oval_topaz.jpg": 86560,
	"./oval_tourmaline.jpg": 87075,
	"./oval_zircon.jpg": 92235,
	"./pear_alexandrite.jpg": 97182,
	"./pear_amethyst.jpg": 64281,
	"./pear_ametrine.jpg": 21452,
	"./pear_apatite.jpg": 12238,
	"./pear_aquamarine.jpg": 35056,
	"./pear_beryl.jpg": 34621,
	"./pear_chrysoberyl.jpg": 6056,
	"./pear_citrine.jpg": 32825,
	"./pear_emerald.jpg": 8687,
	"./pear_garnet.jpg": 27398,
	"./pear_heliodor.jpg": 16553,
	"./pear_iolite.jpg": 43271,
	"./pear_kunzite.jpg": 94965,
	"./pear_moonstone.jpg": 86984,
	"./pear_morganite.jpg": 12955,
	"./pear_opal.jpg": 33346,
	"./pear_peridot.jpg": 10317,
	"./pear_quartz.jpg": 81095,
	"./pear_ruby.jpg": 27260,
	"./pear_sapphire.jpg": 98211,
	"./pear_sphene.jpg": 90074,
	"./pear_spinel.jpg": 48174,
	"./pear_tanzanite.jpg": 1217,
	"./pear_topaz.jpg": 50551,
	"./pear_tourmaline.jpg": 22810,
	"./pear_zircon.jpg": 65333,
	"./princess_alexandrite.jpg": 18195,
	"./princess_amethyst.jpg": 14462,
	"./princess_ametrine.jpg": 29850,
	"./princess_apatite.jpg": 20379,
	"./princess_aquamarine.jpg": 71321,
	"./princess_beryl.jpg": 44177,
	"./princess_chrysoberyl.jpg": 64562,
	"./princess_citrine.jpg": 46096,
	"./princess_emerald.jpg": 31778,
	"./princess_garnet.jpg": 91726,
	"./princess_heliodor.jpg": 76537,
	"./princess_iolite.jpg": 46874,
	"./princess_kunzite.jpg": 30672,
	"./princess_moonstone.jpg": 19054,
	"./princess_morganite.jpg": 18611,
	"./princess_opal.jpg": 65188,
	"./princess_peridot.jpg": 40583,
	"./princess_quartz.jpg": 62105,
	"./princess_ruby.jpg": 18012,
	"./princess_sapphire.jpg": 21890,
	"./princess_sphene.jpg": 34731,
	"./princess_spinel.jpg": 1547,
	"./princess_tanzanite.jpg": 43869,
	"./princess_topaz.jpg": 39810,
	"./princess_tourmaline.jpg": 91286,
	"./princess_zircon.jpg": 8268,
	"./radiant_alexandrite.jpg": 32813,
	"./radiant_amethyst.jpg": 66060,
	"./radiant_ametrine.jpg": 70592,
	"./radiant_apatite.jpg": 37014,
	"./radiant_aquamarine.jpg": 62051,
	"./radiant_beryl.jpg": 69796,
	"./radiant_chrysoberyl.jpg": 20018,
	"./radiant_citrine.jpg": 45730,
	"./radiant_emerald.jpg": 6521,
	"./radiant_garnet.jpg": 66520,
	"./radiant_heliodor.jpg": 83079,
	"./radiant_iolite.jpg": 99198,
	"./radiant_kunzite.jpg": 74058,
	"./radiant_moonstone.jpg": 23713,
	"./radiant_morganite.jpg": 54108,
	"./radiant_opal.jpg": 29044,
	"./radiant_peridot.jpg": 3154,
	"./radiant_quartz.jpg": 25229,
	"./radiant_ruby.jpg": 71555,
	"./radiant_sapphire.jpg": 95279,
	"./radiant_sphene.jpg": 2674,
	"./radiant_spinel.jpg": 54686,
	"./radiant_tanzanite.jpg": 15085,
	"./radiant_topaz.jpg": 28646,
	"./radiant_tourmaline.jpg": 92806,
	"./radiant_zircon.jpg": 11046,
	"./round_alexandrite.jpg": 51349,
	"./round_amethyst.jpg": 55072,
	"./round_ametrine.jpg": 30089,
	"./round_apatite.jpg": 75449,
	"./round_aquamarine.jpg": 97073,
	"./round_beryl.jpg": 89183,
	"./round_chrysoberyl.jpg": 75040,
	"./round_citrine.jpg": 91053,
	"./round_emerald.jpg": 51734,
	"./round_garnet.jpg": 31219,
	"./round_heliodor.jpg": 72425,
	"./round_iolite.jpg": 13161,
	"./round_kunzite.jpg": 71778,
	"./round_moonstone.jpg": 48382,
	"./round_morganite.jpg": 30541,
	"./round_opal.jpg": 55483,
	"./round_peridot.jpg": 55815,
	"./round_quartz.jpg": 29549,
	"./round_ruby.jpg": 18009,
	"./round_sapphire.jpg": 95922,
	"./round_sphene.jpg": 29683,
	"./round_spinel.jpg": 82726,
	"./round_tanzanite.jpg": 80372,
	"./round_topaz.jpg": 40997,
	"./round_tourmaline.jpg": 26349,
	"./round_zircon.jpg": 63872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14104;